import React, { useEffect, useState } from "react";
import axios from "axios";

const CarList = () => {
    const [cars, setCars] = useState([]);

    useEffect(() => {
        axios.get("https://crmb.apitrading.lk/cars/cars")
            .then(res => setCars(res.data))
            .catch(err => console.log(err));
    }, []);

    return (
        <div>
            <h2>Car Inventory</h2>
            <table border="1">
                <thead>
                    <tr>
                        <th>ID</th>
                        <th>Name</th>
                        <th>Brand</th>
                        <th>Category</th>
                        <th>Year</th>
                        <th>PageState</th>
                    </tr>
                </thead>
                <tbody>
                    {cars.map(car => (
                        <tr key={car.id}>
                            <td>{car.id}</td>
                            <td>{car.Name}</td>
                            <td>{car.Brand}</td>
                            <td>{car.Category}</td>
                            <td>{car.year}</td>
                            <td>{car.PageStates}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default CarList;
